<template>
  <el-card style="margin-bottom: 10px">
    <div slot="header" v-if="isShowHeader">
      <div class="card-header">
        <span class="border-left"></span>
        <slot name="card-header"></slot>
      </div>
    </div>
    <slot name="card-body"></slot>
  </el-card>
</template>

<script>
export default {
  name: "workOrderCard",
   props: {
      isShowHeader: {
          type: Boolean,
          default: true,
      },
    },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.card-header {
  position: relative;
  padding: 0 20px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;

  /deep/ h3 {
    margin-block-start: 0 !important;
    margin-block-end: 0 !important;
  }

  .border-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background: #3c78e8;
    border-radius: 2px;
  }
}
</style>
